import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FileService } from '../../services/file.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LearnerService } from '../../services/learner.service';
import { MatSnackBar } from '@angular/material';
import * as  JSZip from 'jszip';
import * as JSZipUtil from 'jszip-utils'
import { saveAs } from "file-saver";
import * as _ from 'lodash';
import { PortfolioService } from 'src/app/services/portfolio/portfolio.service';
import { SharedService } from 'src/app/shared.service';

// let async = require("async");


@Component({
  selector: 'app-learner-allotment-tile',
  templateUrl: './learner-allotment-tile.component.html',
  styleUrls: ['./learner-allotment-tile.component.scss']
})
export class LearnerAllotmentTileComponent implements OnInit {
  @Input('learner') learner: any;

  @Output() openFilesSideNav: EventEmitter<any> = new EventEmitter<any>();
  assignment;
  loadingAssignments: Boolean;
  assignmentDetail;
  loading: boolean = false;
  type = "appear-quiz"
  totalFileSize;
  quizStatus = [];
  downloadProgress = 0;
  showProgressbar: boolean = false;

  var1 = 'p';
  quizList = []

  noAssignmentFiles = {
    title: "No Files!",
    data: "No files added to assignment yet!"
  }

  noQuiz = {
    title: "No Quiz!",
    data: "No quiz added to assignment yet!"
  }
  noData = {
    title: "No Data!",
    data: "Sorry! No data uploaded yet!"
  }
  fileExtensionArray = ['ppt', 'zip', 'pptx', 'mp4', 'xls', 'xlsx', 'txt', 'odt', 'png', 'jpg', 'jpeg', 'pdf', 'doc', 'docx'];
  userRole: any;

  constructor(public _sharedService: SharedService, public _snackBar: MatSnackBar, public _learnerService: LearnerService, public _portfolioService: PortfolioService, public _fileService: FileService, private activatedRoute: ActivatedRoute) {
    this._sharedService.deleteFiles.subscribe((res: any) => {
      if (res == undefined) return
      else {
        console.log("res get ", res, this.fileList);

        if (res)
          this.fileList.splice(this.fileList.findIndex(function (i) {
            return i._id === res;
          }), 1);
      }
    })

  }

  allotmentId;
  fileList = [];
  disable;
  previousIndex
  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      console.log(params['id']);
      this.allotmentId = params['id'];
    });
    console.log("file tile initialized file= ", this.allotmentId);
    this.loadingAssignments = true;
    console.log("this.assignment", this.assignment)
    this.activatedRoute.queryParams.subscribe(qparam => {
      console.log('qparam', qparam);
      if (qparam.userRole) this.userRole = qparam.userRole
      // if (qparam.courseType == 'Level2' && qparam.sessionType) {
      //   // this.getSessionFiles(this.allotmentId, qparam.sessionType)
      // }
      // else {
      // this.getAssignmentFileUsingAllotmentId(this.allotmentId);
      this.getAllotments(this.allotmentId);

      // }
    })


  }



  FileExtension(extension) {
    let index = _.findIndex(this.fileExtensionArray, function (o) { return o == extension; });
    if (index >= 0) {
      return this.fileExtensionArray[index];
    } else {
      return 'default-extension';
    }
  }

  downloadAll() {
    this.openSnackBar("Download will begin automatically", "OK");
    this.showProgressbar = true;
    this.makeZip(this.fileList, this.assignmentDetail.assignment.title).then(() => {
      console.log('All File Download Here');
      this.showProgressbar = false;
    }).catch((error) => {
      console.log('Catch Error Here', error);
    })
  }

  makeZip(fileList, folderName) {
    let count = 0;
    let zip: any = new JSZip();
    let fileArray = fileList;
    let percent = 100 / fileArray.length;
    let download = 0;

    return new Promise((resolve) => {
      if (fileArray && fileArray.length) {
        fileArray.forEach(async file => {
          const result = await this.downloadOne(file)
          let filename = file.path.split("/")[3];
          download = download + percent;
          this.downloadProgress = download;
          console.log("this.downloadProgress===>", this.downloadProgress);
          zip.file(filename, result, { binary: true });
          count++;
          if (count == fileArray.length) {
            zip.generateAsync({ type: 'blob' }).then((content) => {
              saveAs(content, folderName);
              resolve()
            });
          }
        })
      } else {
        this.showProgressbar = false;
        resolve();
      }
    })
  }


  downloadOne(file) {
    return new Promise((resolve) => {
      JSZipUtil.getBinaryContent(file.path, {
        progress(e) {
          console.log("progress Event", e);
        }
      }).then((e) => {
        console.log('Download Complete', e);
        resolve(e)
      })
    })
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  deletedFile(event) {
    this.openSnackBar("File deleted successfully!", "Ok");
    console.log("File Deleted Event : ", event);
  }



  // API Calls

  getAllotments(allotmentId) {
    this.loading = true
    console.log('Get Allotments Called', allotmentId);
    this._learnerService.getAllotedLearnerFilesUsingAllotmentId(allotmentId).subscribe(data => {
      console.log("RECEIVED Allotment = ", data[0])
      this.assignmentDetail = data[0];
      console.log("assign ment details check for msg", this.assignmentDetail)
      this.quizList = this.assignmentDetail.quiz
      this.quizStatus = this.assignmentDetail.quizStatus
      this.fileList = this.assignmentDetail.materialFiles
      if (this.fileList && !this.fileList.length) {
        this.disable = true
      } else {
        this.disable = false
      }
      this.loadingAssignments = false
      this.loading = false
    });
  }


  getAssignmentFileUsingAllotmentId(allotmentId) {
    console.log("getAssignmentFileUsingAllotmentId= ", allotmentId);
    this._fileService.getAssignmentFileUsingAllotmentId(allotmentId).subscribe(data => {
      console.log("assignment files", data);

      this.fileList = data;
      if (this.fileList.length < 1) {
        this.disable = true
      }
      else this.disable = false
      this.loadingAssignments = false
    })
  }

  getSessionFiles(allotmentId, sessionType) {
    this._portfolioService.getSessionFiles(allotmentId, sessionType).subscribe(res => {
      console.log('sessionTypesessionType', res);
      if (res && res.files) {
        this.fileList = res.files
      } else { this.fileList = [] }

      this.loading = false
      this.loadingAssignments = false
    })
  }

  fileDetails(event) {
    console.log("event ====", event);
    this.previousIndex = event.index
    this.openFilesSideNav.emit({ event })
  }

  submissionFile(event) {
    console.log("submission file details======", event);
    this.previousIndex = event.index
    event.file['type'] = "material"
    // this.openFilesSideNav.emit({ event })
    this._fileService.displayFile({ event })
  }

}

